import styled from 'styled-components';

const MyDiv = styled.div`

  .page_heading {
    margin-bottom: 1rem;
  }

  .grid_header {
    display: grid;
    grid-template-columns: 1fr 1fr 2fr 2fr;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .row {
    display: grid;
    grid-template-columns: 1fr 1fr 2fr 2fr;
    gap: 0.75rem;
    margin-bottom: 0.5rem;
    align-items: center;
  }

  .in_time, .out_time {
    display: flex;
    gap: 0.25rem;
  }

  .placeholder-text {
    color: #A0AEC0; 
    font-style: italic;
  }

  .update_btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 1.5rem;
  }
  // .btn{
  //   background-color: #2B6CB0; /* Chakra blue.600 */
  //   color: white;
  //   border: none;
  //   }
`;

export default MyDiv;
